import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from '@mui/material/Button';

const BlueHoverButton = styled(Button)(({ theme }) => ({
    color: '#B8B8B8',
    backgroundColor: '#494949',
    border: '1px solid #B8B8B8',
    boxShadow: 'none',
    borderRadius: 22,
    padding: '7px 20px 6px',
    textTransform: "unset",
    '&:hover': {
        background: 'transparent linear-gradient(79deg, #6D79EC 0%, #8166F5 100%) 0% 0% no-repeat padding-box;',
        border: '1px solid #8166F5',
        color: '#FFFFFF',
        boxShadow: 'none',
    }
}));

export { BlueHoverButton };